import VenueReports from "../components/Dashboard/Reports/VenueReports/VenueReports";
import OrderReports from "../components/Dashboard/Reports/OrderReports/OrderReports.vue";
import GraphicalReports from "../components/Dashboard/Reports/GraphicalReports/GraphicalReports.vue";
import UsersCRMReports from "../components/Dashboard/Reports/UsersCRMReports/UsersCRMReports.vue";
import ProductsCRMReports from "../components/Dashboard/Reports/ProductsCRMReports/ProductsCRMReports.vue";
import ShoppingCRMReports from "../components/Dashboard/Reports/ShoppingCRMReports/ShoppingCRMReports.vue";
import UsersReportsCRMReports from "../components/Dashboard/Reports/UsersReportsCRMReports/UsersReportsCRMReports.vue";
import CampaignCRMReports from "../components/Dashboard/Reports/CampaignCRMReports/CampaignCRMReports.vue";
import StoreReportsCRMReports from "../components/Dashboard/Reports/StoreReportsCRMReports/StoreReportsCRMReports.vue";
import FrinkRecommendCRMReports from "../components/Dashboard/Reports/FrinkRecommendCRMReports/FrinkRecommendCRMReports.vue";
import SalesRefundCRMReports from "../components/Dashboard/Reports/SalesRefundCRMReports/SalesRefundCRMReports.vue";
import SalesCRMReports from "../components/Dashboard/Reports/SalesCRMReports/SalesCRMReports.vue";
import SuggestFriendCRMReports from "../components/Dashboard/Reports/SuggestFriendCRMReports/SuggestFriendCRMReports.vue";
import BudgetReports from "../components/Dashboard/Reports/BudgetReports/BudgetReports.vue";
import StorePointReports from "../components/Dashboard/Reports/StorePointReports/StorePointReports.vue";
import StoreAccountingReports from "../components/Dashboard/Reports/StoreAccountingReports/StoreAccountingReports.vue";
import MonthlyInvoiceDetail from "../components/Dashboard/Reports/MonthlyInvoiceDetail/MonthlyInvoiceDetail.vue";
import MonthlyInvoiceSummary from "../components/Dashboard/Reports/MonthlyInvoiceSummary/MonthlyInvoiceSummary.vue";

const reportsRoutes = [
  {
    path: "reports/venues",
    component: VenueReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelVenueUser", "PanelReportUser"],
    },
    name: "VenueReports",
  },
  {
    path: "reports/graphics",
    component: GraphicalReports,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "GraphicalReports",
  },
  {
    path: "reports/orders",
    component: OrderReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelVenueUser", "PanelReportUser"],
    },
  },
  {
    path: "reports/report-users",
    component: UsersCRMReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelReportUser"],
    },
    name: "UsersCRMReports",
  },
  {
    path: "reports/report-users-report",
    component: UsersReportsCRMReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelReportUser"],
    },
    name: "UsersReportsCRMReports",
  },
  {
    path: "reports/report-products",
    component: ProductsCRMReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelReportUser"],
    },
    name: "ProductsCRMReports",
  },
  {
    path: "reports/report-shopping",
    component: ShoppingCRMReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelReportUser"],
    },
    name: "ShoppingCRMReports",
  },
  {
    path: "reports/report-campaign",
    component: CampaignCRMReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelReportUser"],
    },
    name: "CampaignCRMReports",
  },
  {
    path: "reports/report-store",
    component: StoreReportsCRMReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelReportUser"],
    },
    name: "StoreReportsCRMReports",
  },
  {
    path: "reports/report-store-points",
    component: StorePointReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelReportUser"],
    },
    name: "StorePointReports",
  },
  {
    path: "reports/report-frink-recommend",
    component: FrinkRecommendCRMReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelReportUser"],
    },
    name: "FrinkRecommendCRMReports",
  },
  {
    path: "reports/report-sales",
    component: SalesCRMReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelReportUser"],
    },
    name: "SalesCRMReports",
  },
  {
    path: "reports/report-sales-refund",
    component: SalesRefundCRMReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelReportUser"],
    },
    name: "SalesRefundCRMReports",
  },
  {
    path: "reports/report-suggest-friend",
    component: SuggestFriendCRMReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelReportUser"],
    },
    name: "SuggestFriendCRMReports",
  },
  {
    path: "reports/report-budget-reports",
    component: BudgetReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelReportUser"],
    },
    name: "BudgetReports",
  },
  {
    path: "reports/store-accounting",
    component: StoreAccountingReports,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelVenueUser"],
    },
    name: "StoreAccountingReports",
  },
  {
    path: "reports/store-invoice-detail",
    component: MonthlyInvoiceDetail,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelVenueUser"],
    },
    name: "MonthlyInvoiceDetail",
  },
  {
    path: "reports/store-invoice-summary",
    component: MonthlyInvoiceSummary,
    meta: {
      required: true,
      roles: ["PanelUser", "PanelVenueUser"],
    },
    name: "MonthlyInvoiceSummary",
  },
];

export default reportsRoutes;
